export const MIS_FILTER_KEYS = {
  BUSINESS_PROFILE_KEYS: 'businessProfileKeys',
  CUSTOMER_PARTY_KEYS: 'customerPartyKeys',
  DOCUMENT_KINDS: 'documentKinds',
  STATUSES: 'statuses',
  VAT_CATEGORY_CODES: 'vatCategoryCodes',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PERIOD_PRESET: 'periodPreset',
};

export const MIS_TABS = {
  COMPLIANCE: 'compliance',
  VAT: 'vat',
  INTRA_COMPANY: 'intra-company',
};

export const DEFAULT_MIS_FILTERS = {
  businessProfileKeys: [],
  customerPartyKeys: [],
  documentKinds: [],
  statuses: [],
  vatCategoryCodes: [],
  startDate: null,
  endDate: null,
  periodPreset: null,
};

export const STATUS_CHART_COLORS = {
  APPROVED: 'success',
  PENDING: 'info',
  REJECTED: 'error',
  VALIDATION_FAILED: 'warning',
};

export const MIS_UI = {
  SURFACE_WHITE: '#FFFFFF',
  SURFACE_MUTED: '#F3F4F6',
  SURFACE_HOVER: '#5252FF',
  BORDER: '#E5E7EB',
  TEXT: '#000000',
  TEXT_HOVER: '#FFFFFF',
  TAB_TEXT: '#6B7280',
  TAB_TEXT_SELECTED: '#3A3F4B',
};
